module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('can', {
    attrs: {
      "action": "edit",
      "subject": "timeslots"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "100px",
      "model": _vm.timeslot
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Title"
    },
    model: {
      value: (_vm.timeslot.title),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "title", $$v)
      },
      expression: "timeslot.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Days"
    }
  }, [_c('span', [_c('el-select', {
    attrs: {
      "placeholder": "Start Day"
    },
    model: {
      value: (_vm.timeslot.start_day),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "start_day", $$v)
      },
      expression: "timeslot.start_day"
    }
  }, _vm._l((_vm.weekdays), function(day, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": i,
        "label": day
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "auto 1em"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', [_c('el-select', {
    attrs: {
      "placeholder": "Start Day"
    },
    model: {
      value: (_vm.timeslot.end_day),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "end_day", $$v)
      },
      expression: "timeslot.end_day"
    }
  }, _vm._l((_vm.weekdays), function(day, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "value": i,
        "label": day
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Times"
    }
  }, [_c('span', [_c('el-time-picker', {
    attrs: {
      "value-format": "HH:mm:ss",
      "placeholder": "Start Time"
    },
    model: {
      value: (_vm.timeslot.start_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "start_time", $$v)
      },
      expression: "timeslot.start_time"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "auto 1em"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', [_c('el-time-picker', {
    attrs: {
      "value-format": "HH:mm:ss",
      "placeholder": "End Time"
    },
    model: {
      value: (_vm.timeslot.end_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "end_time", $$v)
      },
      expression: "timeslot.end_time"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Colour"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.timeslot.colour),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "colour", $$v)
      },
      expression: "timeslot.colour"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "dialog-footer clearfix"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.savingTimeslot,
      "plain": ""
    },
    on: {
      "click": _vm.saveTimeslot
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66aefa44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/timeslots/TimeslotEdit.vue
// module id = 3314
// module chunks = 3